import { queryKeys } from "@l2a/shared";
import { CalendarClock, LayoutTemplate, Signature } from "lucide-react";
import { defineFeature } from "../types";

/**
 * CONTRACTS — terms, e-signature and the renewal dates nobody should have to
 * remember (PRD §8 Item 8, US-8.3 and US-8.6).
 *
 * `/c/:token` is registered as a PUBLIC route: no shell, no session. The token
 * carries its workspace inside the HMAC, so a tampered or expired link is a 404
 * and never anything more revealing.
 */
export default defineFeature({
  key: "contracts",
  title: "Contracts",
  entities: ["contract"],
  routes: [
    { path: "contracts", lazy: () => import("./page") },
    // Static before dynamic: /contracts/templates must never be read as an id.
    { path: "contracts/templates", lazy: () => import("./templates") },
    { path: "contracts/:id", lazy: () => import("./detail") },
  ],
  publicRoutes: [{ path: "/c/:token", lazy: () => import("./public") }],
  nav: [
    {
      label: "Contracts",
      to: "/contracts",
      icon: Signature,
      group: "clients",
      order: 20,
      permission: "contracts:read",
      description: "Signatures, terms and renewal dates",
      badgeQueryKey: queryKeys.list("contract", { status: "signed" }),
      badgeTone: "primary",
    },
  ],
  quickCreate: [
    {
      key: "contracts",
      label: "Contract",
      icon: Signature,
      to: "/contracts?new=1",
      permission: "contracts:write",
      description: "Send terms for e-signature",
    },
  ],
  commands: [
    {
      key: "contracts.renewals",
      label: "Contracts up for renewal",
      icon: CalendarClock,
      to: "/contracts?view=renewals",
      group: "actions",
      permission: "contracts:read",
      keywords: ["renewal", "expiring", "notice period"],
    },
    {
      key: "contracts.templates",
      label: "Contract templates",
      icon: LayoutTemplate,
      to: "/contracts/templates",
      group: "navigate",
      permission: "contracts:read",
      keywords: ["clause library", "msa", "sow", "terms"],
    },
  ],
});
